import { render, staticRenderFns } from "./UpdateSpecificData.vue?vue&type=template&id=67c7171e"
import script from "./UpdateSpecificData.vue?vue&type=script&lang=js"
export * from "./UpdateSpecificData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports